// extracted by mini-css-extract-plugin
export default {"carousel-wrapper":"Carousel__carousel-wrapper--sKDmb","carousel-container":"Carousel__carousel-container--SM0ra","carousel-track":"Carousel__carousel-track--kH7W1"};